import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import Breadcrumb from "../../components/Breadcrumb.jsx";
import UserForm from "../../components/forms/UserForm.jsx";
import { api } from "../../utils/apiClient";
import { toast } from 'react-toastify';

const CreateUserPage = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const data = location.state ?? [];

  const handleCreateUser = async (formData, errors,) => {
    if (errors && Object.keys(errors).length > 0) {
      console.warn("Fix form errors before submitting");
      return; //  Don't call API
    }
    // Convert empty selects/text to null before sending
    const payload = {
      ...formData,
      role_id: formData.role_id || null,
      contact: formData.contact || null,
    };

    try {
      const response = await api.post("/users", payload, {
        headers: { "Content-Type": "multipart/form-data" },
      });

      if (response.status === 200 || response.status === 201) {
        toast.success("User created successfully!");
        navigate("/user-data");
      }
    } catch (error) {
      console.error(error);
      toast.error("Error creating user: " + (error.response?.data?.message || error.message));
    }
  };


  return (
    <>
      <Breadcrumb title="User Management" />
      {/* User Form */}
      <UserForm onSubmit={handleCreateUser} roleName={data} />
    </>
  );
};

export default CreateUserPage;
